import { cx } from '@linaria/atomic';
import { styled } from '@linaria/react';
import { URL_MFC_SHARE } from '../../constants/urls';
import "./Share.linaria.module.css!=!./Share?./Share.linaria.module.css?css=H4sIAAAAAAAAA3WSwW6DMBBE7/mKSr20B0c1apvGfAwyZiEG22vZSwpF+fcqJCQhJEfPzBt7tV5LspmsM96WvA5DqQ1BEHsZ3hjTVlYQmUWHahfQAjvZ7+lhtT5ySZHxOvmpu+TuOORSNVXA1hVMocEgKEgXvQzgaKINZvyzTzZ9e3ccvCwK7SpG6MWX7y4AzAFYADkSoZ0xzZxpFoyBkmaEmRNmQQRd7S5I5PuN+k6Kgf1C3mhiOXbMS9UIBY4gpMxGVhq4E8/huo2ky54pdASOJvuJPFFjXaEDKNLohELTWne9aOE8yZ/bCDpiBSgMcrQdOkgfihMhja4c0wQ23j/tOP1oL8afqQ8aCh29kb24aVpox6KreG6+DY6B04973W636eGynxc/lOiIRf0HgnPfpVaGSjvxkRrtgO1g3CpPD6t/c6pSUhQDAAA="
const imageStyles = "atm_aj_1uf1jr atm_2d_1j28jx2";
const imagePaddingStyels = "atm_lo_14y27yu atm_le_14y27yu atm_lk_14y27yu atm_ll_14y27yu";
const StyledAnchor = /*#__PURE__*/styled('a')({
  name: "StyledAnchor",
  class: "s1v7c62d",
  propsAsIs: false
});
interface IShareProps {
  width?: number;
  albums?: number;
  recordings?: number;
  slug?: string;
}
const Share = (props: IShareProps) => {
  const {
    width = 120,
    albums,
    recordings,
    slug
  } = props;
  const albumsText = `${albums} Album${albums > 1 ? 's' : ''}`;
  const recordingsText = `${recordings} Recording${recordings > 1 ? 's' : ''}`;
  return <StyledAnchor href={`${URL_MFC_SHARE}/${slug}`} rel="noopener noreferrer" target="_blank" data-testid="Link__ShareLogo">
            <img src="https://img.mfcimg.com/files/images/misc/MFCShare.svg" style={{
      width
    }} className={cx(imageStyles, (albums > 0 || recordings > 0) && imagePaddingStyels)} />
            {albums > 0 && <p>{albumsText}</p>}
            {recordings > 0 && <p>{recordingsText}</p>}
        </StyledAnchor>;
};
export default Share;